import { GetStaticPaths, GetStaticProps } from "next";
import Link from "next/link";
import { useRouter } from "next/router";

import { CustomNotFoundPage } from "shared/components/templates/CustomNotFoundPage";
import useMainPage from "shared/utils/hooks/useMainPage";

import { OfferNotFoundContainer } from "./styles";

const OfferNotFound = () => {
  const { query } = useRouter();
  const { uuid } = query;
  const mainPage = useMainPage();

  return (
    <OfferNotFoundContainer>
      <CustomNotFoundPage.Container>
        {!!uuid && (
          <CustomNotFoundPage.ItemNotFoundTag>
            Oferta não encontrada: <b>{uuid}</b>
          </CustomNotFoundPage.ItemNotFoundTag>
        )}

        <CustomNotFoundPage.Title>
          Infelizmente não conseguimos encontrar a oferta que você está
          procurando =/
        </CustomNotFoundPage.Title>

        <CustomNotFoundPage.Subtitle>
          Verifique a ortografia do link, confirme se a oferta ainda está ativa
          ou tente acessar novamente.
        </CustomNotFoundPage.Subtitle>

        <Link href={`/${mainPage}`} prefetch={false}>
          <CustomNotFoundPage.RedirectButton>
            Ir para home
          </CustomNotFoundPage.RedirectButton>
        </Link>

        <CustomNotFoundPage.Illustration />
      </CustomNotFoundPage.Container>
    </OfferNotFoundContainer>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
    revalidate: 60 * 1, // 1 minute
  };
};

export default OfferNotFound;
